(ns rothko.editor.mark.transform
  (:require [com.rpl.specter :as sp]
            [medley.core :refer [assoc-some]]
            [rothko.editor.document.navigator :refer [selectionnav]]
            [rothko.editor.document.navigators :as n]
            [rothko.editor.mark.core :as core]))

(defn create-at
  [{:keys [start-index end-index] :as selection} mark]
  [:script
   (n/safe-srange start-index (inc end-index))
   sp/ALL
   (fn [& args]
     (not= :space (-> args last :type)))
   (sp/terminal
    (fn [& args]
      (let [token (last args)]
        (if (not (= :tag (:type token)))
          (update token :marks (fnil conj #{}) mark)
          token))))])

(defn delete-at
  [{:keys [start-index end-index] :as selection}]
  [:script
   (sp/srange start-index (inc end-index))
   sp/ALL
   (sp/terminal
    (fn [& args]
      (let [{:keys [marks] :as token} (last args)
            keep-marks (into #{}
                            (filter #(or (core/system-mark? %)
                                         (:previous-stage? %)))
                            marks)]
        (if-not (empty? keep-marks)
          (assoc token :marks keep-marks)
          (dissoc token :marks)))))])

(def remove-system?-flags
  (sp/with-fresh-collected
    [(sp/collect-one :selection)
     (selectionnav
      []
      (transform*
       [_ {:keys [start-index end-index]} structure next-fn]
       (sp/transform
        [:script
         (sp/srange start-index (inc end-index))
         sp/ALL
         (sp/compact
          :marks
          sp/ALL
          :system?)
         (sp/terminal-val
          sp/NONE)]
        next-fn
        structure)))]))

(def delete
  (selectionnav
   []
   (transform*
    [_ selection structure next-fn]
    (sp/transform
     (delete-at selection)
     next-fn
     structure))))

(def create*
  (selectionnav
   [mark]
   (transform*
    [_ selection structure next-fn]
    (sp/transform
     (create-at selection mark)
     next-fn
     structure))))

(defn create
  [mark]
  (sp/with-fresh-collected
    [(sp/collect-one :selection)
     (create* mark)]))
